import { sendToGtm } from '@s1/core/event-tracking';

const sendSubheadingCountToGA = () => {
  window.s1.wpDataStack = window.s1.wpDataStack || {};

  if (typeof window.s1.wpDataStack.pageInfo.subheading_count !== 'undefined') {
    const trackingObject = {
      event: 'Unified Event',
      eventCategory: 'Subheading Count',
      eventAction: 'Get Subheading Count',
      eventLabel: 'Subheading Count',
      eventValue: window.s1.wpDataStack.pageInfo.subheading_count,
    };

    sendToGtm(trackingObject);
    console.log('SubheadingCount Sent to dataLayer', trackingObject);
  }
};

export default sendSubheadingCountToGA;
